import {
    createFailure,
    getFileExtension,
    validationFailed,
    ValidationResult,
    validationSuccessful
} from "sprint-common-web";

import { isTokenValid, subtitlesTargetFileNameTokens } from "./tokens/subtitlesTargetFileNameTokens";

export const validateSubtitlesTargetFileName = (subtitlesTargetFileName: string | undefined): ValidationResult => {
    if (!subtitlesTargetFileName) {
        return validationSuccessful();
    }

    const tokens = getTokensFromName(subtitlesTargetFileName);

    if (!tokens) {
        const failure = createFailure(
            `Subtitles target file name is missing token. Token should be one of: ${subtitlesTargetFileNameTokens.join(
                ", "
            )}`,
            "subtitlesTargetFileName.MissingToken"
        );

        return validationFailed([failure]);
    }

    for (const token of tokens) {
        if (!isTokenValid(token)) {
            const failure = createFailure(
                `Subtitles target file name has invalid token. Token should be one of: ${subtitlesTargetFileNameTokens.join(
                    ", "
                )}`,
                "subtitlesTargetFileName.InvalidToken"
            );
            return validationFailed([failure]);
        }
    }

    if (hasFileExtension(subtitlesTargetFileName, tokens)) {
        const failure = createFailure(
            "Subtitles target file name should not contain file extension.",
            "subtitlesTargetFileName.ContainsExtension"
        );

        return validationFailed([failure]);
    }

    return validationSuccessful();
};

const hasFileExtension = (subtitlesTargetFileName: string, tokens: RegExpMatchArray) => {
    let fileName = subtitlesTargetFileName;

    tokens.forEach((token) => {
        fileName = fileName.replace(token, "");
    });

    return !!getFileExtension(fileName);
};

const getTokensFromName = (subtitlesTargetFileName: string) => subtitlesTargetFileName.match(/{[a-zA-Z0-9.-]+}/g);
